import { useEffect, useState } from "react";
import axios from "axios";

// Reads an existing list endpoint; never throws, returns [] on failure.
export function useApiList(path) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    axios
      .get(`${window.apiURL}${path}`)
      .then((res) => alive && setData(Array.isArray(res.data) ? res.data : []))
      .catch(() => alive && setData([]));
    return () => {
      alive = false;
    };
  }, [path]);
  return data;
}

export const collectionLink = (c) =>
  `/collection/${String(c.name).toLowerCase().replace(/\s+/g, "-")}/${c.Collection_id}`;
